import { put, takeEvery } from "redux-saga/effects";
import api from "../../../utils/apiService";
import { ENDPOINT } from "../../../config/endpoints";
import {
  closeCashRegister,
  getCashSettlementDetails,
  openCashRegister,
  saveCashSettlementDetails,
} from "../../slices/CashRegisterSlice";
import { closeCashRegisterFunc, openCashRegisterFunc } from "./shared";

export * from "./shared";

/**
 * WEB half of `cashRegister`. Only `fetchCashSettlementDetails` diverges — see `shared.ts`,
 * which owns the two identical workers.
 *
 * ⚠️ Every core import names the VARIANT, not the folder (hazard 6/16): this file knows its
 * platform, so it binds to its own axios instance, endpoint map and slice.
 */
function* fetchCashSettlementDetails(actions: any): Generator<any, void, any> {
  try {
    const response = yield api.request({
      method: "GET",
      url: ENDPOINT.CASH_REGISTER.getCashSettlementDetails,
    });
    if (!response?.code) {
      yield put(
        saveCashSettlementDetails({
          response,
          modalType: actions?.payload?.modalType,
          // WEB ONLY — mobile sends neither field.
          branchSwitchData: actions?.payload?.branchSwitchData || {},
          switchUserData: actions?.payload?.switchUserData || {},
        }),
      );
    } else {
      yield put(
        saveCashSettlementDetails({
          response: {},
        }),
      );
    }
    actions?.payload?.callback && actions?.payload?.callback(response);
  } catch (error) {
    actions?.payload?.callback && actions?.payload?.callback(false);
    console.log(error);
  }
}

export default function* root() {
  yield takeEvery(openCashRegister.type, openCashRegisterFunc);
  yield takeEvery(closeCashRegister.type, closeCashRegisterFunc);
  yield takeEvery(getCashSettlementDetails.type, fetchCashSettlementDetails);
}
